import CustomerModel from "../../people/models/CustomerModel";
import MerchantLocationModel from "../../merchants/models/MerchantLocationModel";
import MerchantModel from "../../merchants/models/MerchantModel";
import UserModel from "@paylani/paylani-react-packages/dist/people/models/UserModel";
import PaymentModel from "../../payments/models/PaymentModel";
import SaleLineItemModel from "./SaleLineItemModel";

class SaleModel { 
    static json = {
        "user_id": "b0fbd67b-596d-4c9a-b841-d4f1ea75e0a8",
        "customer_id": "f2105f1d-4e62-47df-ab15-661a83012e9d",
        "merchant_id": "35ae9fac-9be3-4077-a84c-7ed467062fe5",
        "item_count": 1,
        "payment_count": 2,
        "total": 0.53,
        "tax": 0.03,
        "tax_percent": 0.05,
        "sale_fees": [],
        "fees": 0.0,
        "sub_total": 0.5,
        "tip": 0.0,
        "tip_percent": 0.0,
        "shipping": 0.0,
        "status": 2,
        "invoice_number": null,
        "order_number": null,
        "payments": [
            {
                "sale_id": "952e35c8-da77-411d-96ff-3c2b3c66f769",
                "backoffice_id": null,
                "customer_id": "f2105f1d-4e62-47df-ab15-661a83012e9d",
                "amount": -0.53,
                "payment_type": 9,
                "transaction_id": "0820617094202207051432348358",
                "pos_transaction_id": "2",
                "success": true,
                "auth_code": null,
                "payment_status": 5,
                "message": "Payment has been refunded",
                "signature_image_url": null,
                "credit_card": {
                    "name": null,
                    "last4": "4912",
                    "card_type": 0,
                    "card_type_name": "None",
                    "index": 0
                },
                "backoffice_type": 0,
                "cash": {
                    "amount_paid": 0.0,
                    "change": 0.0
                },
                "card_type": 5,
                "billing_zip": null,
                "is_active": false,
                "is_test_mode": true,
                "pos_transaction_data":"{\"AddlRspData\":{\"ACI\":\"\",\"AthNtwkID\":\"\",\"BankNetData\":\"\",\"CVVErrorCode\":\"\",\"CardLevelResult\":\"\",\"DiscNRID\":\"\",\"DiscPOSEntry\":\"\",\"DiscProcCode\":\"\",\"DiscRespCode\":\"\",\"DiscTransQualifier\":\"\",\"EMVTags\":\"\",\"LocalDateTime\":\"\",\"OrigSTAN\":\"\",\"POSData\":\"\",\"POSEntryMode\":\"\",\"POSEntryModeChg\":\"\",\"ServCode\":\"\",\"SourceReasonCode\":\"\",\"SpendQInd\":\"\",\"TermEntryCapablt\":\"\",\"TranEditErrCode\":\"\",\"TransID\":\"\",\"TrnmsnDateTime\":\"\",\"WltID\":\"\",\"XCodeResp\":\"\"},\"ApprovedAmount\":\"53\",\"AuthCode\":\"1C6RCM\",\"AuthorizationResponse\":\"\",\"AvsResponse\":\"\",\"BogusAccountNum\":\"4912\",\"CardInfo\":{\"CardBin\":\"514377\",\"NewCardBin\":\"\",\"ProgramType\":\"0\"},\"CardType\":\"MASTERCARD\",\"CvResponse\":\"\",\"DebitAccountType\":\"\",\"EDCType\":\"\",\"ExtData\":\"\<BatchNum\>15\</BatchNum\>\<TransactionIdentifier\>0705MDJF562DO  \</TransactionIdentifier\>\<AmountDue\>0\</AmountDue\>\<TipAmount\>0\</TipAmount\>\<CashBackAmount\>0\</CashBackAmount\>\<MerchantFee\>0\</MerchantFee\>\<TaxAmount\>0\</TaxAmount\>\<PLEntryMode\>0\</PLEntryMode\>\<ExpDate\>0823\</ExpDate\>\<PLNameOnCard\>DUGGAN/RICHARD            \</PLNameOnCard\>\<PLCardPresent\>0\</PLCardPresent\>\<ECRRefNum\>1657002287798678\</ECRRefNum\>\<EDCTYPE\>CREDIT\</EDCTYPE\>\<CARDBIN\>514377\</CARDBIN\>\<PROGRAMTYPE\>0\</PROGRAMTYPE\>\<SN\>0820617094\</SN\>\<ReversalStatusNum\>0\</ReversalStatusNum\>\<GlobalUID\>0820617094202207051432348358\</GlobalUID\>\<TC\>F771D3CD0C72250C\</TC\>\",\"ExtraBalance\":\"\",\"FleetCard\":{\"CustomerData\":\"\",\"DepartmentNumber\":\"\",\"DriverId\":\"\",\"EmployeeNumber\":\"\",\"FleetPromptCode\":\"\",\"JobId\":\"\",\"JobNumber\":\"\",\"LicenseNumber\":\"\",\"Odometer\":\"\",\"UserId\":\"\",\"VehicleId\":\"\",\"VehicleNumber\":\"\"},\"GatewayTransactionID\":\"\",\"GiftCardType\":\"\",\"HostCode\":\"218620403570\",\"HostDetailedMessage\":\"\",\"HostResponse\":\"00\",\"IssuerResponseCode\":\"\",\"MaskedPAN\":\"\",\"Message\":\"APPROVAL 1C6RCM\",\"MultiMerchant\":{\"Id\":\"\",\"Name\":\"\"},\"PaymentEmvTag\":{\"Ac\":\"\",\"Aip\":\"\",\"Auc\":\"\",\"Avn\":\"\",\"Cdol2\":\"\",\"Hred\":\"\",\"IacDefault\":\"\",\"IacDenial\":\"\",\"IacOnline\":\"\",\"IssuerAuthData\":\"\",\"TacDefault\":\"\",\"TacDenial\":\"\",\"TacOnline\":\"\",\"Aid\":\"\",\"AppLabel\":\"\",\"AppPreferName\":\"\",\"Arc\":\"\",\"Arqc\":\"\",\"Atc\":\"\",\"Cid\":\"\",\"Cvm\":\"\",\"Iad\":\"\",\"Tc\":\"F771D3CD0C72250C\",\"Tsi\":\"\",\"Tvr\":\"\"},\"PaymentService2000\":\"\",\"PaymentTransInfo\":{\"EdcType\":\"CREDIT\",\"EwicBalance\":\"\",\"EwicBenefitExpd\":\"\",\"EwicDetail\":\"\",\"OrigTip\":\"\",\"PrintLine1\":\"\",\"PrintLine2\":\"\",\"PrintLine3\":\"\",\"PrintLine4\":\"\",\"PrintLine5\":\"\",\"ReversalStatus\":\"0\",\"ReverseAmount\":\"\",\"TokenSerialNum\":\"\",\"ChargedAmount\":\"\",\"DiscountAmount\":\"\",\"Fps\":\"\",\"FpsReceipt\":\"\",\"FpsSignature\":\"\",\"GlobalUid\":\"0820617094202207051432348358\",\"HRef\":\"\",\"HostEchoData\":\"\",\"PinStatusNum\":\"\",\"SN\":\"0820617094\",\"SettlementDate\":\"\",\"SignatureStatus\":\"\",\"Token\":\"\",\"UserLanguageStatus\":\"\",\"ValidationCode\":\"\"},\"RawResponse\":\"\",\"RefNum\":\"2\",\"RemainingBalance\":\"\",\"RequestedAmount\":\"53\",\"Restaurant\":{\"GuestNumber\":\"\",\"TableNumber\":\"\",\"TicketNumber\":\"\"},\"ResultCode\":\"000000\",\"ResultTxt\":\"OK\",\"RetrievalReferenceNumber\":\"\",\"SigFileName\":\"\",\"SignData\":\"\",\"TORResponseInfo\":{\"BatchNo\":\"\",\"GatewayTransactionID\":\"\",\"HostReferenceNumber\":\"\",\"HostResponseCode\":\"\",\"HostResponseMessage\":\"\",\"MaskedPAN\":\"\",\"OrigAmount\":\"\",\"OrigTransAuthCode\":\"\",\"OrigTransDateTime\":\"\",\"OrigTransType\":\"\",\"RecordType\":\"\",\"ReversalAuthCode\":\"\",\"ReversalTimeStamp\":\"\"},\"Timestamp\":\"20220705143234\",\"Track1Data\":\"\",\"Track2Data\":\"\",\"Track3Data\":\"\",\"TransactionIntegrityClass\":\"\",\"TransactionRemainingAmount\":\"\",\"VASResponseInfo\":{\"NDEFData\":\"\",\"VASCode\":\"\"},\"resultCode\":\"\",\"resultTxt\":\"\"}",
                "id": "3ea13d74-adfa-422c-8db1-25919d4b91e5",
                "created": "2022-07-05T20:54:03.05",
                "modified": "2022-07-05T20:54:03.13"
            },
            {
                "sale_id": "952e35c8-da77-411d-96ff-3c2b3c66f769",
                "backoffice_id": null,
                "customer_id": "f2105f1d-4e62-47df-ab15-661a83012e9d",
                "amount": 0.53,
                "payment_type": 1,
                "transaction_id": "0820617094202207051424481852",
                "pos_transaction_id": "1",
                "success": true,
                "auth_code": null,
                "payment_status": 1,
                "message": "Pax credit card payment accepted",
                "signature_image_url": null,
                "credit_card": {
                    "name": null,
                    "last4": "4912",
                    "card_type": 0,
                    "card_type_name": "None",
                    "index": 0
                },
                "backoffice_type": 0,
                "cash": {
                    "amount_paid": 0.0,
                    "change": 0.0
                },
                "card_type": 5,
                "billing_zip": null,
                "is_active": true,
                "is_test_mode": true
            }
        ],
        "products": [
            {
                "sale_id": "952e35c8-da77-411d-96ff-3c2b3c66f769",
                "product_id": "1ac6ab2a-9755-42ad-aea9-26ee6e063073",
                "qty": 1,
                "backoffice_type": 0,
                "gl_code": "",
                "amount": 0.5,
                "is_active": true,
                "name": "Quick Sale Item",
                "image_url": "",
                "sku": "",
                "item_code": "",
                "remote_id": "",
                "price": 0.5,
                "tax": 0.0,
                "is_tax_override": false,
                "cost_per": 0.0,
                "id": "0e8ad9ed-1a7d-4aaf-beef-405ae0d31e38",
                "created": "2022-07-05T20:54:03.05",
                "modified": null
            }
        ],
        "customer": {
            "customer_vault_id": null,
            "backoffice_id": null,
            "remote_id": null,
            "first_name": "RICHARD",
            "last_name": "DUGGAN",
            "name": "RICHARD DUGGAN",
            "company": "",
            "email": "rick@conciergesoftwaredesign .com",
            "phone": "7028216620",
            "payment_type_id": null,
            "payment_type": null,
            "payment_types": null,
            "last4": "4912",
            "card_type": 5,
            "card_type_name": "MasterCard",
            "credit_card": {
                "name": null,
                "last4": "4912",
                "card_type": 5,
                "card_type_name": "MasterCard",
                "index": 0
            },
            "ach": null,
            "card_vault_id": null,
            "user_id": "b0fbd67b-596d-4c9a-b841-d4f1ea75e0a8",
            "profile_image_url": null,
            "merchant_id": "35ae9fac-9be3-4077-a84c-7ed467062fe5",
            "merchant_location_id": "6b4bce1e-e1a9-4f1b-b10e-0f897f33d77b",
            "billing_address_id": null,
            "shipping_address_id": null,
            "billing_address": null,
            "shipping_address": null,
            "status": 0,
            "last_order_date": "2022-07-05T20:54:03.287",
            "customer_number": 37313,
            "order_count": 1,
            "is_active": false,
            "is_test_mode": true,
            "is_validated": false,
            "total_spent": 0.53,
            "cards_on_file": null,
            "id": "f2105f1d-4e62-47df-ab15-661a83012e9d",
            "created": "2022-07-05T20:54:03.05",
            "modified": "2022-07-05T20:55:09.353"
        },
        "sale_number": 48198,
        "lat": "",
        "lon": "",
        "discount_id": null,
        "discount_amount": 0.0,
        "discount": null,
        "sale_fields": [],
        "merchant_location_id": "6b4bce1e-e1a9-4f1b-b10e-0f897f33d77b",
        "signature_image_url": null,
        "invoice_date_formatted": "Jul 05, 2022 8:54 PM",
        "sale_date": "2022-07-05T20:54:03.05",
        "sale_date_formatted": "Jul 05, 2022 8:54 PM",
        "backoffice_shipping_method_id": null,
        "user_label": null,
        "user": null,
        "is_test_mode": true,
        "pos_type": 2,
        "pos_type_name": "Pax",
        "pos_sale_id": "",
        "id": "952e35c8-da77-411d-96ff-3c2b3c66f769",
        "created": "2022-07-05T20:54:03.05",
        "modified": "2022-07-05T21:01:28.803"
    };
    
    static mockSales = [
        new SaleModel({ id: '000-001', total: 200, subTotal: 200, created: new Date().addMinutes(-17), saleNumber: 30001, merchantId: '' }),
        new SaleModel({ id: '000-002', total: 300, subTotal: 300, created: new Date().addMinutes(-22), saleNumber: 30002, merchantId: '' }),
        new SaleModel({ id: '000-003', total: 400, subTotal: 400, created: new Date().addMinutes(-32), saleNumber: 30003, merchantId: '' }),
        new SaleModel({ id: '000-004', total: 500, subTotal: 500, created: new Date().addMinutes(-44), saleNumber: 30004, merchantId: '' }),
        new SaleModel({ id: '000-005', total: 600, subTotal: 600, created: new Date().addMinutes(-52), saleNumber: 30005, merchantId: '' }),
        new SaleModel({ id: '000-006', total: 700, subTotal: 700, created: new Date().addMinutes(-5622), saleNumber: 30006, merchantId: '' }),
        new SaleModel({ id: '000-007', total: 800, subTotal: 800, created: new Date().addMinutes(-62), saleNumber: 30007, merchantId: '' }),
        new SaleModel({ id: '000-008', total: 900, subTotal: 900, created: new Date().addMinutes(-71), saleNumber: 30008, merchantId: '' }),
        new SaleModel({ id: '000-009', total: 1000, subTotal: 1000, created: new Date().addMinutes(-87), saleNumber: 30009, merchantId: '' }),
    ];
    
    constructor(json) {
        let message = null;
        
        if (typeof json === "string") { 
            message = json;
            json = {};
        } else if (typeof json?.data === "object") { 
            const data = json.data;
            message = data.message;
            if (!message) message = JSON.stringify(data);
        }
        
        if (!json) json = {};
        
        this.userId = json.user_id;
        this.customerId = json.customer_id;
        this.merchantId = json.merchant_id;
        this.merchantLocationId = json.merchant_location_id;
        this.itemCount = json.item_count;
        this.paymentCount = json.payment_count;;
        this.total = json.total;
        this.tax = json.tax;
        this.taxAmount = json.tax_amount;
        this.discount = json.discount;
        this.discountAmount = json.discount_amount;
        this.saleNumber = json.sale_number;
        this.fees = json.fees;
        this.subTotal = json.sub_total;
        this.tipPercent = json.tip_percent;
        this.shipping = json.shipping;
        this.status = json.status_key || (json.status || 0);
        this.statusName = (this.status === 8) ? "Invoiced" : json.status_name;
        
        this.customer = new CustomerModel(json.customer);
        this.location = new MerchantLocationModel(json.location);
        this.merchant = new MerchantModel(json.merchant);
        this.user = new UserModel(json.user);

        this.payments = PaymentModel.fromJsonArray(json.payments);
        this.lineItems = SaleLineItemModel.fromJsonArray(json.line_items);
        
        if (!message && this.payments.length > 0) { 
            message = this.payments[0].message;
        }
        
        this.message = message;

        this.id = json.id;
        
        this.created = json.created ? new Date(json.created) : null;
        this.modified = json.modified ? new Date(json.modified) : null;
    }
    
    static fromJsonArray(jsonArray) { 
        if (!jsonArray || !Array.isArray(jsonArray)) return [];
        return jsonArray.map(json => new SaleModel(json));
    }

    /**
     * @param sale {SaleModel}
     * @param term {string}
     * @returns {boolean}
     */
    static searchFor(sale, term) {
        const ft = (term || "").toLowerCase();
        
        if (sale.customer !== null) {
            const name = ((sale.customer.lastName || "") + ' ' + (sale.customer.firstName || "")).trim().toLowerCase();
            if (name.indexOf(ft) > -1 || (sale.customer.email || "").toLowerCase().indexOf(ft) > -1 || (sale.customer.phone || "").toLowerCase().indexOf(ft) > -1) return true;
        }
        if (sale.saleNumber.toString().indexOf(ft) > -1) return true;
        return (ft.indexOf(".") > -1 && ("$" + sale.total.toString()).indexOf(ft) > -1);        
    }
    
    static createSaleJson(amount, customer) {
        return {
            customer_id: (customer?.id || null),
            payments: [],
            user_label_id: null,
            products: [{
                qty: 1,
                tax: 0,
                remote_id: "",
                item_code: "",
                status: 1,
                sku: "",
                name: "Virtual Terminal Sale",
                price: amount,
                product_id: "00000000-0000-0000-0000-000000000000",
                is_tax_override: false
            }],
            sales_fees: [],
            fees: 0,
            tax: 0,
            sub_total: amount,
            order_number: "",
            tip: 0,
            destinations: [],
            discount_amount: 0,
            customer: customer || null,
            discount_id: null,
            shipping: 0,
            invoice_number: "",
            backoffice_shipping_method_id: "",
            total: amount,
            sale_fields: []
        };        
    }
}

export default SaleModel;
